<div class="modal-body bg-light p-0" *transloco="let t">
  <div class="bg-white" [class.mb-3]="!importService.settingImportData.isFinal">
    <!--- Handle tabs ------------------------------------------------------------------>
    <div class="d-lg-flex justify-content-between align-items-center mt-2">
      <app-c-nav-tabs
        [navTabs]="navTabs"
        (tabEvent)="onChangeTab($event)"
        />
        @if (importService.settingImportData.tabRef == 'excel' || (importService.settingImportData.tabRef == 'googleSheets' && accessTokenOptions.length)) {
          <div
            class="d-lg-flex flex-1 justify-content-between px-3 mt-3 mt-lg-0 pb-3 pb-lg-0">
            @if (importService.settingImportData.tabRef == 'googleSheets') {
              <div
                class="accessTokenOptions input-group d-flex mb-3 mb-lg-0">
                <!-- Tài khoản kết nối -->
                <app-d-select
                  class="flex-1"
            [iconRight]="{
                                icon: 'fal fa-trash-alt text-danger',
                            }"
                  [classInput]="'radius-right-0'"
                  [label]="'order.connectedAccount'"
                  [data]="accessTokenOptions"
                  [values]="[importService.settingImportData.accessTokenId ? importService.settingImportData.accessTokenId : null]"
                  (changeSelect)="onSelectedToken($event)"
                  (confirmClickIcon$)="onRevokeTokenGGS($event)"
                  />
                  <div class="input-group-text text-success cursor-pointer"
                    [title]="t('common.add.connectedAccount')"
                    (click)="onGenerateAuthURL()">
                    <i class="fa fa-plus"></i>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>


      <!--- Start process is running ------------------------------------------------------------------>
      @if (importService.settingImportData.isRunning) {
        <!--- Process ------------------------------------------------------------------>
        @if (!importService.settingImportData.isFinal) {
          <div class="d-flex p-3">
            <p class="mb-0 me-3">
              <i class="fa-light fa-chevron-dow me-3"></i>
              {{ t('common.entering.data') }}:
              <span class="currentItem">
                {{ importService.settingImportData.progressPaginator.totalHandleItems }}
              </span>/
              <span class="totalItems">{{ importService.settingImportData.progressPaginator.totalItems }}</span>
            </p>
            <div class="flex-1">
              <app-progress-bar
                [totalPages]="importService.settingImportData.progressPaginator.totalItems"
                [currentPage]="importService.settingImportData.progressPaginator.totalHandleItems"/>
              </div>
            </div>
          }
          <!--- End Process ------------------------------------------------------------------>
          <app-import-excel-common-log [service]="this.importService" [useOnlyContent]="true"/>
        }
        <!--- End process is running ------------------------------------------------------------------>

        <!----------------------------------------------------------------------------------------->
        <!----- Start Google Sheets ---------------------------------------------------------------->
        <!----------------------------------------------------------------------------------------->
        @if (importService.settingImportData.tabRef == 'googleSheets') {
          @if (isLoadingTabGGSheet) {
            @if (!accessTokenOptions.length || tokenError) {
              <!----- Yêu cầu cấp & xác nhận token ---------------------------------------------------------------->
              <div class="w-100 p-3 pt-0 text-center" data-title="Yêu cầu kết nối tài khoản">
                @if (!tokenError) {
                  <div class="alert alert-warning fw-semibold">
                    {{ t('export.data.noAccessToken') }}
                  </div>
                } @else {
                  <div class="alert alert-danger fw-semibold">
                    {{ t('googleSheets.noAccessToken') }}
                  </div>
                }
                <button type="button" class="btn btn-primary fw-semibold"
                  [disabled]="appForm.disabledSubmit"
                  (click)="onGenerateAuthURL()">
                  <i class="fa-brands fa-google"></i>
                  <span class="ms-2">{{ t('common.loginWithGoogle') }}</span>
                </button>
                @if (tokenError) {
                  <div class="text-center mt-3">
                    <app-img-custom className="img-fluid"
                      [src]="'/assets/img/sample/Google_Sheets_Allow_Permission.jpg' | imgCdn" alt=""/>
                    </div>
                  }
                </div>
                @if (options && options.configModal?.btnClose?.display !== false) {
                  <div class="d-flex justify-content-end bg-white w-100 p-3"
                    >
                    <button type="button" class="btn btn-light btn-sm fw-semibold" (click)="activeModal.dismiss()">
                      {{ t('common.close') }}
                    </button>
                  </div>
                }
              }
            } @else {
              <div class="p-3 pt-0 text-center">
                <app-spin-loader/>
                <h6>{{ 'common.loading.data.pleaseWait' | transloco }}</h6>
              </div>
            }
          }
          <!----- End Google Sheet ---------------------------------------------------------------->

          <!--------------------------------------------------------------------------------------->
          <!----- Start render body ---------------------------------------------------------------->
          <!--------------------------------------------------------------------------------------->
          @if (!importService.settingImportData.isRunning && (
            importService.settingImportData.tabRef != 'googleSheets' ||
            (accessTokenOptions.length && !tokenError)
            )
            ) {
            <div class="alert-import-data alert-p-last-child alert alert-info mb-3 mx-3"
              >
              @if (importService.settingImportData.tabRef == 'googleSheets') {
                <a class="fw-bold" target="_blank"
                  [href]="options.urlApi | uriFileExcelExample:'ggs':'link'">
                  <i class="fal fa-external-link me-1"></i>
                  {{ 'common.open.templateFile' | transloco }}:
                </a>
                <div class="d-inline-block" [innerHTML]="'common.file.copyAndShare.editPermission' | transloco"></div>
              } @else {
                <b class="me-2">{{ 'common.download.templateFile' | transloco }}:</b>
                <a class="fw-semibold" [href]="options.urlApi | uriFileExcelExample:'excel':'link'" download="">
                  <i class="fal fa-file-excel"></i>
                  {{ options.urlApi | uriFileExcelExample:'excel' }}
                </a>
              }
            </div>
          }

  <div id="_viewContRef" [class.d-none]="
    importService.settingImportData.isRunning ||
    (
        importService.settingImportData.tabRef == 'googleSheets' &&
        (!accessTokenOptions.length || tokenError)
    )
    ">
            <ng-container #container></ng-container>
          </div>
          <!--------------------------------------------------------------------------------------->
          <!----- End render body ---------------------------------------------------------------->
          <!--------------------------------------------------------------------------------------->

          <!----- Footer ---------------------------------------------------------------->
          @if (!importService.settingImportData.isRunning &&
            (importService.settingImportData.tabRef == 'excel' || accessTokenOptions.length)) {
            <div
              class=" w-100 p-3 {{(options && options.configModal?.bgFooter) || 'bg-light'}}">
              <div class="d-flex justify-content-between">
                @if (!importService.settingImportData.isFinal) {
                  <button type="button" class="btn btn-success btn-sm text-nowrap fw-semibold"
              [disabled]="
                            importService.settingImportData.isImportSubmit ||
                            (
                            importService.settingImportData.tabRef == 'googleSheets' && (
                                !importService.settingImportData.accessTokenId ||
                                 !importService.settingImportData.spreadUrl ||
                                  !importService.settingImportData.spreadSheetTitle
                            )
                            )
                        "
                    (click)="onImportData()">
                    <i class="fal {{(options && options.configModal?.btnSave?.icon) || 'fa-save'}} me-2"></i>
                    {{ t((options && options.configModal?.btnSave?.label) || 'common.save') }}
                  </button>
                }
                @if (options && options.configModal?.btnClose?.display !== false) {
                  <button type="button" class="btn btn-light btn-sm text-nowrap fw-semibold"
                    (click)="activeModal.dismiss()">
                    {{ t('common.close') }}
                  </button>
                }
              </div>
            </div>
          }
        </div>


        <ng-template #contentTemplate>
          @if (importService.settingImportData.tabRef == 'googleSheets') {
            <div class="row mb-3">
              <!---- Bảng tính ----->
              <div class="col-xl-6 col-12" data-title="Bảng tính">
                <h6 class="fw-semibold mb-2">{{ 'excel.worksheet' | transloco }}</h6>
                <div [class.disableds]="!importService.settingImportData.accessTokenId">
                  <app-floating-invalid [errorOriginal]="errors['spreadId']">
                    <input type="text"
                      class="form-control showPlaceholder"
                      placeholder="https://docs.google.com/spreadsheets/..."
                      [class.border-danger]="!!errors['spreadId']"
                      [class.pe-4]="!!errors['spreadId']"
                      (change)="onChangeSpreadGGUrl(importService.settingImportData.spreadUrl)"
                      [(ngModel)]="importService.settingImportData.spreadUrl"
                      >
                    </app-floating-invalid>
                  </div>
                </div>
                <!---- Trang tính ----->
                <div class="col-xl-6 col-12" data-title="Trang tính">
                  <h6 class="fw-semibold mt-2 mt-lg-0 mb-2">{{ 'excel.spreadsheet' | transloco }}</h6>
                  <div [class.disableds]="!importService.settingImportData.accessTokenId">
                    <!-- Trang tính đã có sẵn -->
                    <app-d-select
                      class="w-100 flex-1"
                      [disabled]="!importService.settingImportData.spreadUrl || errors['spreadId'] || !sheetOptions.length"
                      [fieldInvalid]="!!errors['spreadSheetId']"
                      [data]="sheetOptions"
          [values]="[
                            importService.settingImportData.spreadSheetId ?
                            importService.settingImportData.spreadSheetId : ''
                        ]"
                      (changeSelect)="onChangSheetId($event)"
                      />
                    </div>
                  </div>
                </div>
              }
            </ng-template>

